import React, {useState} from 'react';
import {Link} from 'react-router-dom'

import TechnologySmallIcon from '../../components/technologySmallIcon.js'
import useGoogleCaptcha from '../../components/useReCaptcha.js';
import WebsiteScanForm from '../../components/scanWebsite.js'

import {PreparedAppResult, PreparedCategoryResult, PreparedSearchResult, SearchPageResult} from '../../../../server/routes/search.js'

interface SearchProps {
    server: string;
    pageData: unknown;
}

interface SearchSucceededProps {
    props: SearchPageResult;
}

interface SearchResultProps {
    searchResult: PreparedSearchResult;
}

interface SearchResultAppProps {
    searchResult: PreparedAppResult;
}

interface SearchResultCategoryProps {
    searchResult: PreparedCategoryResult;
}

interface SearchFailedProps {
    google: wts_approved_any;
    props: SearchPageResult;
}

export default function Search({server, pageData}: SearchProps) {

	let [data, setData] = useState(pageData as SearchPageResult);
    const google = useGoogleCaptcha();

	return (<>

        {
            data.custom404 ? 
            <SearchFailed google={google} props={data} />:
            <SearchSucceeded props={data} />
        }
    </>)
}

function SearchSucceeded({props}: SearchSucceededProps) {

    return (<>

        <section className="section section-2 text-left">
            <div className= "container">
                <div className="row">
                    <div className="col">
                        <h2>Search for {props.SearchTerm}</h2>
                        returned {props.SearchResults?.length || 0} results
                        <br/>
                        <br/>
                        <br/>
                    </div>
                </div>
                {
                    props.SearchResults?.map((searchResult, indexKey) =>
                        <SearchResult searchResult={searchResult} key={indexKey}/>
                    )
                }
            </div>
        </section>
    </>)
}

function SearchResult({searchResult}: SearchResultProps) {
    return (<>
    
        <div className="row">
            {
                'App' in searchResult &&
                    <SearchResultApp searchResult={searchResult as PreparedAppResult}/>
            }
            {
                'Category' in searchResult &&
                    <SearchResultCategory searchResult={searchResult as PreparedCategoryResult}/>
            }
        </div>
    </>)
}

function SearchResultApp({searchResult}: SearchResultAppProps) {
    return (<>
        <div className="col-12 col-md-8">
            <Link 
                to={`/technology/${searchResult.URL}`}
                className="link-hover" 
                title={`${searchResult.Name} customers list, historic trends, and recent website additions`} 
                >
                    <TechnologySmallIcon 
                        technologyIcon={searchResult.Icon}
                        technology={searchResult.Name}
                    />
                    {' '}{searchResult.Name}
                </Link>
                {' '}- technology
        </div>
        <div className="col-12 col-md-8">
            Category:{' '}
                <span 
                    className={`icon text-primary mdi ${searchResult.AppCategory.CategoryIcon}`}
                ></span> 
                {' '}{searchResult.AppCategory.Category}
        </div>
        {
            searchResult.Description &&
            <div className="col-12 col-md-8">
                {searchResult.Description}
            </div>
        }
    </>)
}

function SearchResultCategory ({searchResult}: SearchResultCategoryProps){

    return (<>
        <div className="col-12 col-md-8">
            <Link 
                to={`/technology-type/${searchResult.URL}`}
                className="link-hover" 
                title={`${searchResult.Name} market share and usage statistic`} 
            >
                <span className={`icon text-primary mdi ${searchResult.Icon}`}></span>
                {' '}<b>{searchResult.Name}</b>
            </Link> - category
        </div>
        {
            searchResult.Description &&
            <div className="col-12 col-md-8">
                {searchResult.Description}
            </div>
        }
    </>)
}

function SearchFailed({google,props}: SearchFailedProps) {
    let domain: string = '';

    const regExp: RegExp = /^(?:https?:\/\/)*((?:[a-z0-9-.]+)+\.[a-z]+)\/?$/g;
    const match: RegExpExecArray | null = regExp.exec(props.q?.trim() || '');
    if (match !== null) {
        domain = match[1];
    }

    return (<>
        <section className="section section-2 text-left">
            <div className= "container">
                <h4>The technology or website you were looking for was not found.</h4>
                <br/>
                <p>
                A live scan can be run to provide real-time technology data for any specific website that is not currently in our database.
                </p>
                <div className="row row-50">
                    <div className="col-md-8 col-lg-8 col-xl-8">
                        <WebsiteScanForm    
                            props={props}
                            reCaptchaSiteKey={props.ReCaptchaSiteKey}
                            google={google}
                            domain={domain}
                            readonly={false}
                            /> 
                    </div>
                </div>  
            </div>
        </section>
    </>)
}
